import React from 'react';
import {
  Tooltip,
} from 'antd';
import styles from './index.module.less';

export type ExceedTooltipProps = {
  colValue: string;
  maxLength?: number;
  className?: any;
}
const ExceedTooltip: React.FC<ExceedTooltipProps> = ({ colValue, maxLength = 20,className }) => {
  const text = colValue && colValue.length > maxLength ? colValue.substring(0, maxLength) + '...' : colValue || '';
  const show = colValue && colValue.length > maxLength;
  if(show) {
    return (<Tooltip overlayClassName={colValue.length > 100 ? styles.exceedTooltip : ''} placement="top" title={colValue}>{text}</Tooltip>);
  } else {
    return <div className={className}>{colValue}</div>;
  }
};

export default ExceedTooltip;
